/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MonthReports } from './MonthReports';
import {
    MonthReportsFromJSON,
    MonthReportsFromJSONTyped,
    MonthReportsToJSON,
    MonthReportsToJSONTyped,
} from './MonthReports';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';

/**
 * 
 * @export
 * @interface ResponseMonthReport
 */
export interface ResponseMonthReport {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseMonthReport
     */
    result: ResponseResult;
    /**
     * 
     * @type {MonthReports}
     * @memberof ResponseMonthReport
     */
    data: MonthReports;
}

/**
 * Check if a given object implements the ResponseMonthReport interface.
 */
export function instanceOfResponseMonthReport(value: object): value is ResponseMonthReport {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseMonthReportFromJSON(json: any): ResponseMonthReport {
    return ResponseMonthReportFromJSONTyped(json, false);
}

export function ResponseMonthReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseMonthReport {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': MonthReportsFromJSON(json['data']),
    };
}

export function ResponseMonthReportToJSON(json: any): ResponseMonthReport {
    return ResponseMonthReportToJSONTyped(json, false);
}

export function ResponseMonthReportToJSONTyped(value?: ResponseMonthReport | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': MonthReportsToJSON(value['data']),
    };
}

